import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MapPin, Search, CheckCircle2, XCircle } from "lucide-react";
import { Link } from "react-router-dom";

export const ZipCodeChecker = () => {
  const [zip, setZip] = useState("");
  const [result, setResult] = useState<'idle' | 'success' | 'error'>('idle');

  const handleCheck = (e: React.FormEvent) => {
    e.preventDefault();
    if (zip.length >= 5) {
      // Mock logic: CA zip codes start with 9, AZ with 8
      if (zip.startsWith("9") || zip.startsWith("8")) {
        setResult('success');
      } else {
        setResult('error');
      }
    }
  };

  return (
    <div className="bg-card border rounded-2xl p-6 shadow-sm max-w-md w-full mx-auto relative overflow-hidden">
      <div className="absolute top-0 left-0 w-1 h-full bg-primary" />
      <h3 className="text-lg font-bold mb-2 flex items-center gap-2">
        <MapPin className="h-5 w-5 text-primary" />
        Check Your Zip Code
      </h3>
      <p className="text-sm text-muted-foreground mb-4">
        Enter your zip code to see if we service your exact neighborhood.
      </p>

      <form onSubmit={handleCheck} className="flex gap-2 mb-4">
        <Input
          type="text"
          placeholder="Enter Zip Code (e.g. 95814)"
          value={zip}
          onChange={(e) => {
            setZip(e.target.value.replace(/\D/g, '').slice(0, 5));
            setResult('idle');
          }}
          className="flex-1"
          maxLength={5}
          required
        />
        <Button type="submit" disabled={zip.length < 5}>
          <Search className="h-4 w-4 mr-2" />
          Check
        </Button>
      </form>

      {result === 'success' && (
        <div className="bg-green-500/10 text-green-700 dark:text-green-400 p-3 rounded-lg flex items-start gap-3 animate-in fade-in slide-in-from-bottom-2">
          <CheckCircle2 className="h-5 w-5 shrink-0 mt-0.5" />
          <div>
            <p className="font-semibold text-sm">Great news!</p>
            <p className="text-xs mt-0.5 mb-2">We provide premium cleaning services in your area.</p>
            <Button asChild size="sm" className="w-full h-8 text-xs">
              <Link to="/book">Get Your Free Quote</Link>
            </Button>
          </div>
        </div>
      )}

      {result === 'error' && (
        <div className="bg-destructive/10 text-destructive p-3 rounded-lg flex items-start gap-3 animate-in fade-in slide-in-from-bottom-2">
          <XCircle className="h-5 w-5 shrink-0 mt-0.5" />
          <div>
            <p className="font-semibold text-sm">Outside Service Area</p>
            <p className="text-xs mt-0.5">We don't currently serve this zip code, but we are expanding rapidly!</p>
          </div>
        </div>
      )}
    </div>
  );
};
